<template>
  <v-toolbar
    class="elevation-1"
    app
    fixed
    color="white"
  >
    <v-toolbar-side-icon
      @click.stop="onToggleDrawer"
    />
    <!-- end toolbar-side-icon -->

    <v-toolbar-title>
      Dual Link M.E
    </v-toolbar-title>
    <!-- end toolbar-title -->

    <v-spacer />
    <!-- end spacer -->

    <v-toolbar-items>
      <v-btn icon>
        <v-icon>help</v-icon>
      </v-btn>
      <!-- end help button -->

      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <!-- end notifications button -->

      <v-btn icon>
        <v-icon>history</v-icon>
      </v-btn>
      <!-- end history button -->
    </v-toolbar-items>
    <!-- end toolbar-items -->
  </v-toolbar>
  <!-- end toolbar -->
</template>

<script>
export default {
  data: () => ({}),
  methods: {
    onToggleDrawer () {
      this.$root.$data.drawerIsActive = !this.$root.$data.drawerIsActive
    }
  }
}
</script>

<style scoped>
.logo {
  display: block;
  position: relative;
  max-height: 3.25rem;
}
.logo img {
  display: block;
  position: relative;
  min-width: 100%;
  max-height: 3rem;
}
</style>
